import { Col } from 'antd';
import styled from 'styled-components';

export const Card = styled(Col)`
  border: 1px solid #e5e5e5;
  &:not(:first-child) {
    border-left: none;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--spacing-04);

  > *:first-child {
    display: inline-flex;
    flex-direction: column;
    gap: var(--spacing-02);
  }

  Button {
    padding: 0;
    height: initial;
    font-size: var(--font-size-sm);
  }

  &.more-options-card {
    > *:first-child {
      gap: var(--spacing-03);
    }
  }
`;

export const Title = styled.p`
  color: var(--gray-80);
  font-size: var(--font-size-sm);
  margin: 0;
  line-height: var(--line-height-code-01);
`;
